// MapModal Constants

export const STRUCTURE_TYPES = {
    // MFA Types
    NEW_MFA: { id: 'NEW_MFA', label: 'New MFA Structure', color: [14, 165, 233, 0.42], outline: [2, 132, 199], saveable: true },  // Sky Blue
    EXISTING_MFA: { id: 'EXISTING_MFA', label: 'Existing MFA Structure', color: [14, 165, 233, 0.32], outline: [2, 132, 199], saveable: true },  // Sky Blue
    
    // MDA Types
    NEW_MDA: { id: 'NEW_MDA', label: 'New MDA Structure', color: [168, 85, 247, 0.42], outline: [126, 34, 206], saveable: true },  // Purple
    EXISTING_MDA: { id: 'EXISTING_MDA', label: 'Existing MDA Structure', color: [168, 85, 247, 0.30], outline: [126, 34, 206], saveable: true },  // Purple
    
    // Legacy Types (for backward compatibility)
    EXTEND_MFA: { id: 'EXTEND_MFA', label: 'Extended Structure', color: [14, 165, 233, 0.42], outline: [2, 132, 199], saveable: true },  // Sky Blue
    MDA: { id: 'MDA', label: 'MDA / Accessory', color: [168, 85, 247, 0.42], outline: [126, 34, 206], saveable: true },  // Purple (treated as NEW_MDA)
    INVALID: { id: 'INVALID', label: 'Invalid', color: [239, 68, 68, 0.6], outline: [255, 255, 255], saveable: false }
};

export const GEOMETRY_SERVICE_URL = "https://tasks.arcgisonline.com/ArcGIS/rest/services/Geometry/GeometryServer";

export const GIS_LAYERS = {
    SCC: {
        PROPERTY: "https://services2.arcgis.com/tcv2cMrq63AgvbHF/arcgis/rest/services/Parcels_Public_View/FeatureServer/0",
        BUILDINGS: "https://tiles.arcgis.com/tiles/mXU5U9yHw5e9X9lU/arcgis/rest/services/California_Building_Footprints/MapServer/0",
        GEOMETRY_SERVICE: GEOMETRY_SERVICE_URL,
        USA_STRUCTURES: "https://services2.arcgis.com/FiaPA4ga0iQKduv3/ArcGIS/rest/services/USA_Structures_View/FeatureServer/0",
        MS_BUILDINGS: "https://services.arcgis.com/P3ePLMYs2RVChkJx/ArcGIS/rest/services/Microsoft_Building_Footprints/FeatureServer/0"
    },
    ALAMEDA: {
        PROPERTY: "https://services5.arcgis.com/ROBnTHSNjoZ2Wm1P/ArcGIS/rest/services/Parcels/FeatureServer/0",
        BUILDINGS: "https://tiles.arcgis.com/tiles/mXU5U9yHw5e9X9lU/arcgis/rest/services/California_Building_Footprints/MapServer/0",
        GEOMETRY_SERVICE: GEOMETRY_SERVICE_URL,
        GEOMETRY_SERVICE_PROJECT: "https://utility.arcgisonline.com/ArcGIS/rest/services/Geometry/GeometryServer/project", // Specific for projection fallback
        USA_STRUCTURES: "https://services2.arcgis.com/FiaPA4ga0iQKduv3/ArcGIS/rest/services/USA_Structures_View/FeatureServer/0",
        MS_BUILDINGS: "https://services.arcgis.com/P3ePLMYs2RVChkJx/ArcGIS/rest/services/Microsoft_Building_Footprints/FeatureServer/0"
    },
    SAN_MATEO: {
        PROPERTY: "https://gis.smcgov.org/maps/rest/services/Common/ACTIVE_PARCELS_APN/MapServer/0",
        BUILDINGS: "https://tiles.arcgis.com/tiles/mXU5U9yHw5e9X9lU/arcgis/rest/services/California_Building_Footprints/MapServer/0",
        GEOMETRY_SERVICE: GEOMETRY_SERVICE_URL,
        USA_STRUCTURES: "https://services2.arcgis.com/FiaPA4ga0iQKduv3/ArcGIS/rest/services/USA_Structures_View/FeatureServer/0",
        MS_BUILDINGS: "https://services.arcgis.com/P3ePLMYs2RVChkJx/ArcGIS/rest/services/Microsoft_Building_Footprints/FeatureServer/0"
    },
    CONTRA_COSTA: {
        PROPERTY: "https://ccmap.cccounty.us/arcgis/rest/services/CCMAP/Assessment_Parcels_ArcPro/MapServer/0",
        BUILDINGS: "https://tiles.arcgis.com/tiles/mXU5U9yHw5e9X9lU/arcgis/rest/services/California_Building_Footprints/MapServer/0",
        GEOMETRY_SERVICE: GEOMETRY_SERVICE_URL,
        USA_STRUCTURES: "https://services2.arcgis.com/FiaPA4ga0iQKduv3/ArcGIS/rest/services/USA_Structures_View/FeatureServer/0",
        MS_BUILDINGS: "https://services.arcgis.com/P3ePLMYs2RVChkJx/ArcGIS/rest/services/Microsoft_Building_Footprints/FeatureServer/0"
    },
    MARIN: {
        PROPERTY: "https://services6.arcgis.com/T8eS7sop5hLmgRRH/arcgis/rest/services/Parcels/FeatureServer/0",
        BUILDINGS: "https://tiles.arcgis.com/tiles/mXU5U9yHw5e9X9lU/arcgis/rest/services/California_Building_Footprints/MapServer/0",
        GEOMETRY_SERVICE: GEOMETRY_SERVICE_URL,
        USA_STRUCTURES: "https://services2.arcgis.com/FiaPA4ga0iQKduv3/ArcGIS/rest/services/USA_Structures_View/FeatureServer/0",
        MS_BUILDINGS: "https://services.arcgis.com/P3ePLMYs2RVChkJx/ArcGIS/rest/services/Microsoft_Building_Footprints/FeatureServer/0"
    },
    NAPA: {
        PROPERTY: "https://services1.arcgis.com/Ko5rxt00spOfjMqj/arcgis/rest/services/Napa_County_Public_Parcels/FeatureServer/1",
        BUILDINGS: "https://tiles.arcgis.com/tiles/mXU5U9yHw5e9X9lU/arcgis/rest/services/California_Building_Footprints/MapServer/0",
        GEOMETRY_SERVICE: GEOMETRY_SERVICE_URL,
        USA_STRUCTURES: "https://services2.arcgis.com/FiaPA4ga0iQKduv3/ArcGIS/rest/services/USA_Structures_View/FeatureServer/0",
        MS_BUILDINGS: "https://services.arcgis.com/P3ePLMYs2RVChkJx/ArcGIS/rest/services/Microsoft_Building_Footprints/FeatureServer/0"
    },
    SOLANO: {
        PROPERTY: "https://solanocountygis.com/server/rest/services/Aumentum/AumentumInternal/MapServer/6",
        BUILDINGS: "https://tiles.arcgis.com/tiles/mXU5U9yHw5e9X9lU/arcgis/rest/services/California_Building_Footprints/MapServer/0",
        GEOMETRY_SERVICE: GEOMETRY_SERVICE_URL,
        USA_STRUCTURES: "https://services2.arcgis.com/FiaPA4ga0iQKduv3/ArcGIS/rest/services/USA_Structures_View/FeatureServer/0",
        MS_BUILDINGS: "https://services.arcgis.com/P3ePLMYs2RVChkJx/ArcGIS/rest/services/Microsoft_Building_Footprints/FeatureServer/0"
    },
    CALAVERAS: {
        PROPERTY: "https://gisportal.calaverascounty.gov/server/rest/services/Hosted/GISPARCELS_PARCELS_PUBLIC/FeatureServer/0",
        APN_FIELD: "name",
        BUILDINGS: "https://tiles.arcgis.com/tiles/mXU5U9yHw5e9X9lU/arcgis/rest/services/California_Building_Footprints/MapServer/0",
        GEOMETRY_SERVICE: GEOMETRY_SERVICE_URL,
        USA_STRUCTURES: "https://services2.arcgis.com/FiaPA4ga0iQKduv3/ArcGIS/rest/services/USA_Structures_View/FeatureServer/0",
        MS_BUILDINGS: "https://services.arcgis.com/P3ePLMYs2RVChkJx/ArcGIS/rest/services/Microsoft_Building_Footprints/FeatureServer/0"
    },
    COLLIN: {
        PROPERTY: "https://services2.arcgis.com/uXyoacYrZTPTKD3R/arcgis/rest/services/CCAD_Parcel_Feature_Set/FeatureServer/4",
        APN_FIELD: "geoID",
        BUILDINGS: "https://services.arcgis.com/P3ePLMYs2RVChkJx/arcgis/rest/services/MSBFP2/FeatureServer/0",
        GEOMETRY_SERVICE: GEOMETRY_SERVICE_URL,
        USA_STRUCTURES: "https://services2.arcgis.com/FiaPA4ga0iQKduv3/ArcGIS/rest/services/USA_Structures_View/FeatureServer/0",
        MS_BUILDINGS: "https://services.arcgis.com/P3ePLMYs2RVChkJx/ArcGIS/rest/services/Microsoft_Building_Footprints/FeatureServer/0"
    },
    DENTON: {
        PROPERTY: "https://gis.dentoncounty.gov/arcgis/rest/services/CAD_GC/MapServer/0",
        APN_FIELD: "prop_id",
        BUILDINGS: "https://services.arcgis.com/P3ePLMYs2RVChkJx/arcgis/rest/services/MSBFP2/FeatureServer/0",
        GEOMETRY_SERVICE: GEOMETRY_SERVICE_URL,
        USA_STRUCTURES: "https://services2.arcgis.com/FiaPA4ga0iQKduv3/ArcGIS/rest/services/USA_Structures_View/FeatureServer/0",
        MS_BUILDINGS: "https://services.arcgis.com/P3ePLMYs2RVChkJx/arcgis/rest/services/Microsoft_Building_Footprints/FeatureServer/0"
    }
};

/**
 * RGB to Hex converter for save payload
 */
export const rgbToHex = (r, g, b) => '#' + [r, g, b].map(x => {
    const hex = Math.round(x).toString(16);
    return hex.length === 1 ? '0' + hex : hex;
}).join('');
